import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 封装axios
import axios from 'axios'
Vue.prototype.$axios = axios
import qs from 'qs'
Vue.prototype.$qs = qs

// npm i lib-flexible-computer -S //根节点会根据页面视口变化而变化font-size大小
// npm i px2rem-loader -D//自动将px转换为rem
// npm i postcss-px2rem//将代码中px自动转化成对应的rem的一个插件
import "lib-flexible-computer";

//导入全局请求
import request from '@/utils/request.js';
Vue.prototype.BASE_URL = request.BASE_URL
Vue.prototype.$request = request.request;
import tool from './utils/tool.js'
Vue.use(tool)

// 动画库
import animated from 'animate.css'
Vue.use(animated)

import ElementUI from 'element-ui'
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css'

import vuescroll from 'vuescroll'
Vue.use(vuescroll) 

// jquery
import $ from 'jquery'
Vue.prototype.$ = $

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
